import React from 'react';
import styles from './Chips.module.scss';

type ChipsProps = {
  label: string | React.ReactNode;
  onClick?: () => void;
  className?: string;
  icon?: React.ReactNode;
  variant?: 'success' | 'error' | 'warning' | 'info';
};

const chipsStyle = 'chips';

const Chips: React.FC<ChipsProps> = ({ label, onClick, className, icon
  , variant = 'info'
}) => {
  return (
    <div
      className={[styles[chipsStyle], styles[chipsStyle + '__' + variant], className].join(' ')}
      onClick={onClick}
    >
      {icon && <span style={{ display: 'flex', alignItems: 'center' }}>{icon}</span>}
      {label}
    </div>
  );
};

export default Chips;